/** @file gizmoFrameOf: the gizmo meshes' input for this frame from the viewport's state (null: no gizmo). */
import { gizmoAccess } from './gizmoAccess';
import { gizmoFor } from './gizmoFor';
import type { GizmoFrame } from './gizmoFrame';
import type { ViewportCtx } from './viewportCtx';
import { yawZero } from './yawZero';

/**
 * `gizmoFor`'s placement with the handles `gizmoAccess` lets the tool draw (none: no gizmo; the IK tool shows the move
 * centre square on a joint with an IK chain), scene units per CSS pixel at the current fit, the hovered handle and
 * the running rotate drag's arc.
 */
export function gizmoFrameOf(ctx: ViewportCtx): GizmoFrame | null {
  const at = gizmoFor(ctx);
  if (at === null || ctx.scene === null || at.tool === 'hand') return null;
  const show = gizmoAccess(ctx.store.getState(), at.tool).show;
  if (show === 0) return null;
  const view = ctx.scene.camera.view();
  const tool = at.tool === 'ik' ? 'move' : at.tool;
  return {
    tool, model: at.model, size: at.size, px: at.pxPerCss / view.pixelsPerUnit, view, hover: ctx.hover, arc: ctx.edit?.arc ?? null, show,
    yawZeroRad: yawZero(at.model, ctx.store.getState().space, ctx.puppet()),
  };
}
